import { createCommonContextProvider } from "@poscon/shared-frontend";
import { useRootDispatch } from "~/redux/hooks";
import { setViewPosition } from "~/redux/slices/eramStateSlice";
import type { EramView } from "~/types/eramView";
import { processEramMessage } from "~redux/thunks/processEramMessage";

export const CCommonContextProvider = createCommonContextProvider(
  () => {
    const dispatch = useRootDispatch();
    return (view, pos) => dispatch(setViewPosition({ view: view as EramView, pos }));
  },
  () => {
    const dispatch = useRootDispatch();
    return (command) => dispatch(processEramMessage(command, true));
  },
);
